import React, { useState, useEffect, useCallback} from "react";
import {
    Paper,
    Typography,
    makeStyles,
    TextField,
    Grid,
    FormControl,
    Select,
    MenuItem,
    Button,
    Divider,
    Icon,
    darken,
    Backdrop,
    ButtonGroup,
    Hidden,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import clsx from "clsx";
import Feedback from "../../../atoms/Feedback";
import {
    getRequestForQuotes,
    getRequestForQuote,
    updateRequestForQuote,
    submitRequestForQuote
} from "../../../../actions/purchasingActions";
import { getProfile } from "../../../../actions/userActions";
// import { getDivisionMonthlyBudgetItems } from "../../../actions/monthlyBudgetAction";
// import { formatCurrency } from "../../../utils";
import { getDivisionYearAnnualBudgetLines } from "../../../../actions/annualAction";

// Procurement Division
import AcceptRFQModal from "../modals/AcceptRFQModal";
import DeclineRFQModal from "../modals/DeclineRFQModal";
import JustifyRFQModal from "../modals/JustifyRFQModal";

const useStyles = makeStyles((theme) => ({
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold"
    },
    title2: {
        display: "block",
        fontSize: 12,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontWeight: "bold",
        fontFamily: "Rubik",
    },
    title3: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
    },
    appBar: {
        // position: "relative",
        zIndex: 9000,
    },
    container: {
        marginTop: theme.spacing(6),
        padding: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    paper: {
        padding: theme.spacing(1),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    option: {
        fontSize: 15,
        "& > span": {
            marginRight: 10,
            fontSize: 18,
        },
    },
    textField: {
        marginBottom: theme.spacing(3),
    },
    paper2: {
        padding: "2px 20px 2px 5px",
        width: "60%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
            width: "100%",
        },
        "&:nth-of-type(2n)": {
            color: theme.palette.background.paper,
            backgroundColor: theme.palette.primary.main,
        },
    },
    dialogContent: {
        [theme.breakpoints.down("sm")]: {
            padding: "8px 14px",
        },
    },
    tabPanel: {
        padding: 14,
    },
    divider: {
        marginBottom: 10,
    },
    divider2: {
        height: 28,
        margin: 4,
    },
    total: {
        marginTop: 40,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    warningInfo: {
        color: "#f5f5f5",
        background: "#f44336",
        padding: 20,
        marginBottom: 20,
        marginRight: 10,
        "& > *": {
            fontWeight: 900,
        },
    },
    form: {
        marginTop: 20,
    },
    grid: {
        marginBottom: 20,
    },
    input: {
        border: "1px solid #bdbdbd",
        padding: theme.spacing(2),
        borderRadius: 3,
    },

    btnWrapper: {
        textAlign: "center",
    },

    saveBtn: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 240,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    saveBtn2: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 240,
        background: "#388e3c",
        color: "#fff",
        "&:hover": {
            background: darken("#388e3c", 0.15),
            // color: "#fff",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    backBtn: {
        letterSpacing: 2.5,
        padding: theme.spacing(1.2),
        paddingLeft: 20,
        paddingRight: 20,
    },
    status: {
        width: "fit-content",
        color: "#979292",
        padding: 6,
        background: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    statusTitle: {
        color: "#b5b5b5",
        fontSize: "0.75rem",
    },
    statusDarkGreen: {
        borderColor: "#4caf50",
    },
    statusGreen: {
        borderColor: "#1de9b6",
    },
    statusYellow: {
        borderColor: "#fbc02d",
    },
    statusRed: {
        borderColor: "#ef5350",
    },
    statusOrange: {
        borderColor: "#ff9800",
    },
    embed: {
        width: "100%",
        height: 100,
        objectFit: "contain",
        objectPosition: "center",
        marginRight: 5,
        cursor: "pointer",
        transition: "all 300ms ease-in-out",
        zIndex: 1,
        "&:hover": {
            transform: "scale(2.5)",
            zIndex: 1000000000000,
        },
    },
    audit: {
        padding: 10,
        fontFamily: "Rubik",
        fontSize: 10,
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        // fontWeight: 500,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditTitle: {
        padding: 10,
        // background: theme.palette.grey[600],
        color: theme.palette.type === "light" ? theme.palette.grey[600] : "#cccccc",
        fontFamily: "Rubik",
        fontSize: 10,
        fontWeight: "bold",
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditContainer: {
        width: "100%",
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    link: {
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    centered: {
        textAlign: "center",
    },
    paperBlack: {
        color: "#f5f5f5",
        // background: "#3c3737",
        background: theme.palette.grey.A400,
        marginTop: 10,
        marginBottom: 10,
        padding: 5,
        textAlign: "center",
        maxWidth: 480,
        marginLeft: "auto",
        marginRight: "auto",
    },
    info2: {
        marginBottom: 20,
        fontWeight: 500,
    },
    small: {
        display: "block",
        fontSize: 10,
        lineHeight: 1.5,
        letterSpacing: 1.2,
        fontFamily: "Rubik",
        color: theme.palette.warning.main,
    },
}));

const INIT_STATE = {
    employee: "",
    employeeId:"",
    vendor: "",
    month: "",
    year: "",
    division: "",
    purchaseRequisition: "",
    requisitionType: "",
    purchaseType:"",
    shippingType:"",
    purpose: "",
    dateNeeded: "",
    items: [],
};

const ViewRFQ = () => {
    const classes = useStyles();
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);
    const [justifyData, setJustificationData] = useState(INIT_STATE);
    // const { divItems } = useSelector((state) => state.monthlyBudget);
    const { annualBudgetLines } = useSelector((state) => state.annualBudget);

    const [openAccept, setOpenAccept] = useState(false);
    const [openDecline, setOpenDecline] = useState(false);
    const [openJustification, setOpenJustification] = useState(false);

    const [feed, setFeed] = useState({
        loading: false,
        open: false,
        message: "",
        success: false,
    });

    const { profile } = useSelector((state) => state.user);
    const { error, loading, rfq } = useSelector((state) => state.rfq);

    useEffect(() => {
        if (error && error !== null) {
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: error,
                success: false,
            }));
        }
    }, [error]);

    useEffect(() => {
        dispatch(getRequestForQuotes());
        dispatch(getRequestForQuote(id));
        dispatch(getProfile)
    }, [dispatch, id]);

    
    useEffect(() => {
        setState((prev) => ({
            ...prev,
            employee: (rfq && rfq.employee) || "",
            division: (rfq && rfq.division) || "",
            dateNeeded: (rfq && moment(rfq.dateNeeded).format("l")) || "",            
            month: (rfq && rfq.month) || "",
            year: (rfq && rfq.year) || "",
            vendor: (rfq && rfq.vendor) || "",

            purchaseRequisition: (rfq && rfq.purchaseRequisition) || "",

            items: (rfq && rfq.items) || [],
            status: (rfq && rfq.status) || "",
            documentNo: (rfq && rfq.documentNo) || "",

            createdBy: (rfq && rfq.createdBy) || "",
            createdAt: (rfq && rfq.createdAt) || "",

            submittedBy: (rfq && rfq.submittedBy) || "",
            submittedAt: (rfq && rfq.submittedAt) || "",

            approvedBy: (rfq && rfq.approvedBy) || "",
            approvedAt: (rfq && rfq.approvedAt) || "",
            approveComment: (rfq && rfq.approveComment) || "",
            
            rejectedBy: (rfq && rfq.rejectedBy) || "",
            rejectedAt: (rfq && rfq.rejectedAt) || "",
            rejectComment: (rfq && rfq.rejectComment) || "",

            acceptedBy: (rfq && rfq.acceptedBy) || "",
            acceptedAt: (rfq && rfq.acceptedAt) || "",
            acceptComment: (rfq && rfq.acceptComment) || "",

            declinedBy: (rfq && rfq.declinedBy) || "",
            declinedAt: (rfq && rfq.declinedAt) || "",
            declineComment: (rfq && rfq.declineComment) || "",

        }));
    }, [rfq]);

    // console.log(rfq)

    // useEffect(() => {
    //     if((state.status === "submitted" || state.status === "accepted") && (state.items && state.items.length > 0)){
    //         const quantity = state.items.reduce((acc, cur) => { return acc + +cur.quantityNeeded; }, 0);
            
    //         setState((prev) => ({
    //             ...prev,
    //             totalQuantityNeeded: quantity,
    //         }));
    //     }
    // }, [state]);

    // useEffect(() => {
    //     if((state.status === "submitted" || state.status === "accepted") && (state.items && state.items.length > 0)){
    //         const budgeted = state.items.reduce((acc, cur) => { return acc + +cur.budgetAmount; }, 0);

    //         setState((prev) => ({
    //             ...prev,
    //             totalBudgetAmount: budgeted,
    //         }));
    //     }
    // }, [state]);

    // useEffect(() => {
    //     if((state.status === "submitted" || state.status === "accepted") && (state.items && state.items.length > 0)){
    //         const quoted = state.items.reduce((acc, cur) => { return acc + +cur.quotedAmount; }, 0);

    //         setState((prev) => ({
    //             ...prev,
    //             totalQuotedAmount: quoted,
    //         }));
    //     }
    // }, [state]);

    // useEffect(() => {
    //     if((state.status === "submitted" || state.status === "accepted") && (state.items && state.items.length > 0)){
    //         const extended = state.items.reduce((acc, cur) => { return acc + +cur.extendedCost; }, 0);

    //         setState((prev) => ({
    //             ...prev,
    //             totalExtendedAmount: extended,
    //         }));
    //     }
    // }, [state]);

    // const getDivisionMonthlyBudgetItemsCallback = useCallback(() => {
    //     let data = {
    //         year: state.year && state.year,
    //         month: state.month && state.month,
    //         serviceDivision: state && state.division._id,
    //     };
    //     dispatch(getDivisionMonthlyBudgetItems(data));
    // }, [dispatch, state]);

    // useEffect(() => {
    //     getDivisionMonthlyBudgetItemsCallback();
    // }, [getDivisionMonthlyBudgetItemsCallback]);

    // use annual budget
    const getDivisionYearAnnualBudgetLinesCallback = useCallback(() => {
        if(state.division !==""){
            let data = {
                year: state.year && state.year,
                division: state && state.division._id,
            };
            dispatch(getDivisionYearAnnualBudgetLines(data));
        }
    }, [dispatch, state]);

    useEffect(() => {
        getDivisionYearAnnualBudgetLinesCallback();
    }, [getDivisionYearAnnualBudgetLinesCallback]);


    const handleCloseFeed = () => {
        setFeed((prevState) => ({ ...prevState, open: false }));
    };

    // procurement
    const handleOpenAccept = () => {
        setOpenAccept(true);
    };
    const handleCloseAccept = () => {
        setOpenAccept(false);
    };
    const handleOpenDecline = () => {
        setOpenDecline(true);
    };
    const handleCloseDecline = () => {
        setOpenDecline(false);
    };

    const handleOpenJustification = (data, item) => {
        setJustificationData({data, item})
        setOpenJustification(true);
    };
    const handleCloseJustification = () => {
        setOpenJustification(false);
    };

    const isCanEdit = state ? state.status &&
        ((state.status === "draft" || state.status === "declined")
        )
        : false;

    const handleSave = async (e) => {
        e.preventDefault();
        let budgeted = state.items.map((item) => parseFloat(item.budgetAmount)).reduce((prev, curr) => prev + curr, 0);
        let quoted = state.items.map((item) => parseFloat(item.quotedAmount)).reduce((prev, curr) => prev + curr, 0);
        quoted = Math.round(quoted * 100) / 100;
        
        if((budgeted > 0) && (quoted > 0)){
            const data = {
                items: state.items,
                id
            }
            await dispatch(updateRequestForQuote(data));
            setTimeout(async () => {
                await dispatch(getRequestForQuote(id));
                setFeed((prev) => ({
                    loading: false,
                    open: !prev.open,
                    message: "RFQ Updated Successfully.",
                    success: true,
                }));
            }, 500);
        }else {
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: "Please enter at least one quoted amount before saving",
                success: false,
            }));
        }
    };

    // capture item changes
    const handleItemChange = (i) => (e) => {
        e.persist();
        const newItems = state.items.map((item, index) => {
            if (i !== index) {
                return item;
            }

            if((e.target.name === "quotedAmount") && (parseFloat(item.budgetAmount) / parseInt(item.quantityNeeded)) >= e.target.value){
                return {
                    ...item,
                    extendedCost: (item.quantityNeeded * e.target.value),
                    [e.target.name]: e.target.value || '',
                };
            }else if((e.target.name === "quotedAmount") && (e.target.value > (parseFloat(item.budgetAmount) / parseInt(item.quantityNeeded)))){
                handleOpenJustification(state.items, item);
                return {
                    ...item,
                };

            }else if(e.target.name === "quantityNeeded"){
                return {
                    ...item,
                    quotedAmount: "",
                    extendedCost: "",
                    quantityNeeded: e.target.value || '',
                };
            }else if(e.target.name === "description"){
                return {
                    ...item,
                    [e.target.name]: e.target.value || '',
                };
            }else {
                return {
                    ...item,
                };
            }
        });
        setState((prev) => ({
            ...prev,
            items: newItems,
        }));
    };

    const handleSubmitHandler = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
            items: state.items,
            id,
            path: `purchasing/rfq/view/${id}`
        };
        await dispatch(submitRequestForQuote(data));
        await dispatch(getRequestForQuote(id));
        setFeed((prev) => ({
            loading: false,
            open: !prev.open,
            message: "RFQ Submitted Successfully.",
            success: true,
        }));
        setTimeout(() => {
            history.push("/purchasing/requestforquote");
        }, 1500);
    };

    const isProcurement = profile
        ? profile &&
        profile.division &&
        ((profile?.division?.code === "PMG") || (profile?.division?.code === "SCM"))
        : false;

    const isAdmin = profile
        ? profile &&
        profile.groups &&
        profile.groups.some(
            (grp) => grp.name === "admin" 
        )
        : false;

    const validCheck = () => {
        let budgeted = state.items.map((item) => item.budgetAmount).reduce((prev, curr) => prev + curr, 0);
        let quoted = state.items.map((item) => item.quotedAmount).reduce((prev, curr) => prev + curr, 0);
        if(budgeted < 0 && quoted < 0){return true}else {return false}
    };

    return (
        <div>
            {feed.success ? (
                <Feedback
                    handleCloseFeed={handleCloseFeed}
                    open={feed.open}
                    severity="success"
                    message={feed.message}
                />
            ) : (
                <Feedback
                    handleCloseFeed={handleCloseFeed}
                    open={feed.open}
                    severity="error"
                    message={feed.message}
                />
            )}

            {/* Procurement */}
            <AcceptRFQModal {...{ openAccept, handleCloseAccept, id }} />
            <DeclineRFQModal {...{ openDecline, handleCloseDecline, id }} />
            <JustifyRFQModal {...{ openJustification, handleCloseJustification, id, justifyData }} />
            
            <Typography variant="overline" className={classes.title}>
                View RFQ
            </Typography>
            <Grid container justify="space-between" alignItems="center" spacing={2}>
                <Grid item>
                    <Button
                        color="primary"
                        variant="contained"
                        className={classes.backBtn}
                        startIcon={<ArrowBackIosIcon />}
                        onClick={() => history.push("/purchasing/requestforquote")}
                    >
                        Back
                    </Button>
                </Grid>
                <Grid item>
                    <Paper variant="outlined" className={classes.status}>
                        <Typography variant="overline" className={classes.statusTitle}>
                            Document No.
                        </Typography>
                        <Divider className={classes.divider2} orientation="vertical" />
                        {loading ? "Loading..." : state.documentNo}
                    </Paper>
                </Grid>
            </Grid>

            <Grid
                container
                justify="space-between"
                alignItems="center"
                spacing={2}
                style={{ marginBottom: 20 }}
            >
                <Hidden smDown>
                    <Grid item></Grid>
                </Hidden>
                <Grid item>
                    <Paper
                        variant="outlined"
                        className={clsx(
                            state.status === "draft"
                                ? classes.statusYellow
                                : state.status === "submitted"
                                    ? classes.statusOrange
                                    : (state.status === "accepted" || state.status === "approved" || state.status === "confirmed" || state.status === "consented") ? classes.statusGreen
                                        : (state.status === "issued" || state.status === "collected" || state.status === "transferred" || state.status === "returned" || state.status === "received" || state.status === "completed")
                                            ? classes.statusDarkGreen
                                            : classes.statusRed,
                            classes.status
                        )}
                    >
                        <Typography variant="overline" className={classes.statusTitle}>
                            Status
                        </Typography>
                        <Divider className={classes.divider2} orientation="vertical" />
                        <Typography variant="overline" className={classes.statusTitle}>
                            {loading ? "Loading..." : state.status}
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>

            <form onSubmit={handleSubmitHandler}>
                <Grid container spacing={2} className={classes.grid}>
                    <Grid item xs={12} md={4}>
                        <label style={{ fontWeight: "bold" }}>Vendor Company Name</label>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            disabled
                            value={(state.vendor && state.vendor.companyName) || ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label style={{ fontWeight: "bold" }}>Vendor Email</label>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            disabled
                            value={(state.vendor && state.vendor.email) || ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label style={{ fontWeight: "bold" }}>Employee</label>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            disabled
                            value={(state.createdBy && state.createdBy.userName) || ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label style={{ fontWeight: "bold" }}>Division/Unit</label>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            disabled
                            value={(state.division && state.division.name) || ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label style={{ fontWeight: "bold" }}>Document No</label>
                        <TextField
                            variant="outlined"
                            fullWidth
                            value={state.documentNo || ""}
                            disabled
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label style={{ fontWeight: "bold" }}>Date Needed</label>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            disabled
                            value={state.dateNeeded || ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label style={{ fontWeight: "bold" }}>Month</label>
                        <TextField
                            variant="outlined"
                            fullWidth
                            value={(state.month && state.month) || ""}
                            disabled
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <label style={{ fontWeight: "bold" }}>Year</label>
                        <TextField
                            variant="outlined"
                            fullWidth
                            value={(state.year && state.year) || ""}
                            disabled
                            required
                        />
                    </Grid>
                </Grid>

                <Typography variant="overline" className={classes.title2}>
                    Purchase Requisition Details
                </Typography>

                <Paper variant="outlined" square className={classes.paper}>
                    <Grid container spacing={2} className={classes.grid2}>
                        <Grid item xs={12} md={3}>
                            <label style={{ fontWeight: "bold" }}>Requisition Type</label>
                            <FormControl fullWidth variant="outlined" required>
                                <Select
                                    inputProps={{
                                        id: "requisitionType",
                                        name: "requisitionType",
                                    }}
                                    disabled
                                    value={state.purchaseRequisition.requisitionType || ""}
                                >
                                    <MenuItem value="Service">Service</MenuItem>
                                    <MenuItem value="Product">Product</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <label style={{ fontWeight: "bold" }}>Shipping Type</label>
                            <FormControl fullWidth variant="outlined" required>
                                <Select
                                    labelId="shippingType"
                                    inputProps={{
                                        id: "shippingType",
                                        name: "shippingType",
                                    }}
                                    disabled
                                    value={state.purchaseRequisition.shippingType || ""}
                                >
                                    <MenuItem value="Digital">Digital (Download)</MenuItem>
                                    <MenuItem value="Vendor">Vendor Delivery</MenuItem>
                                    <MenuItem value="Courier">Courier</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <label style={{ fontWeight: "bold" }}>Purchase Type</label>
                            <FormControl fullWidth variant="outlined" required>
                                <Select
                                    labelId="purchaseType"
                                    inputProps={{
                                        id: "purchaseType",
                                        name: "purchaseType",
                                    }}
                                    disabled
                                    value={state.purchaseRequisition.purchaseType || ""}
                                >
                                    <MenuItem value="Vendor">Vendor</MenuItem>
                                    <MenuItem value="Open Market">Open Market</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <label style={{ fontWeight: "bold" }}>Vendor Type</label>
                            <FormControl fullWidth variant="outlined" required>
                                <Select
                                    labelId="vendorType"
                                    inputProps={{
                                        id: "vendorType",
                                        name: "vendorType",
                                    }}
                                    disabled
                                    value={state.purchaseRequisition.vendorType || ""}
                                >
                                    <MenuItem value="Contract">Contract</MenuItem>
                                    <MenuItem value="Sole Source">Sole Source</MenuItem>
                                    <MenuItem value="Regular">Regular (3 Quotes)</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Paper>

                {isCanEdit ? 
                <Paper variant="outlined" square className={classes.paper}>
                    <Typography variant="overline" className={classes.title2}>
                        Please enter the quoted amount from the Vendor for each of the items. You cannot enter an amount greated than the budget amount.
                    </Typography>
                </Paper> : null }

                {state.items.map((sitem, i) => (
                <Paper variant="outlined" square className={classes.paper} key={i}>
                    <Grid
                        container
                        spacing={2}
                        className={classes.grid}
                    >
                        <Grid item xs={12} md={isCanEdit ? 3 : 4}>
                            <FormControl fullWidth variant="outlined" required>
                                <label style={{ fontWeight: "bold" }}>Budget Item</label>
                                <Select
                                        inputProps={{
                                            id: "budgetItem",
                                            name: "budgetItem",
                                        }}
                                        value={sitem.budgetItem || ""}
                                        disabled
                                    >
                                        <MenuItem disabled>Select</MenuItem>
                                        {annualBudgetLines &&
                                            annualBudgetLines.map((item) => (
                                                <MenuItem key={item._id} value={item._id}>
                                                    {item?.item?.name}
                                                </MenuItem>
                                            ))
                                        }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={isCanEdit ? 3 : 4}>
                            <label style={{ fontWeight: "bold" }}>Description</label>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="description"
                                value={sitem.description || ""}
                                onChange={handleItemChange(i)}
                                disabled={!isCanEdit}
                            />
                        </Grid>
                        <Grid item xs={12} md={isCanEdit ? 2 : 4}>
                            <label style={{ fontWeight: "bold" }}>Quantity ({sitem.unit || ""})</label>
                            <TextField
                                variant="outlined"
                                fullWidth
                                required
                                type="text"
                                name="quantityNeeded"
                                value={sitem.quantityNeeded || ""}
                                onChange={handleItemChange(i)}
                                disabled={!isCanEdit}
                            />
                        </Grid>
                        <Grid item xs={12} md={isCanEdit ? 2 : 4} >
                            <FormControl fullWidth variant="outlined" required>
                                <label style={{ fontWeight: "bold" }}>Budget Amount</label>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    type="text"
                                    name="budgetAmount"
                                    value={((sitem.budgetAmount && sitem.budgetAmount) || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') || ""}
                                    disabled
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={isCanEdit ? 2 : 4} >
                            <FormControl fullWidth variant="outlined" required>
                                <label style={{ fontWeight: "bold" }}>Quoted Amount</label>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    disabled={!isCanEdit}
                                    type="text"
                                    name="quotedAmount"
                                    value={sitem.quotedAmount || ""}
                                    onChange={handleItemChange(i)}
                                    helperText={
                                        <Typography variant="overline" className={classes.small}>
                                            Quoted Amount must not be more than {(parseFloat(sitem.budgetAmount) / parseInt(sitem.quantityNeeded)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                        </Typography>
                                    }
                                />
                            </FormControl>
                        </Grid>
                        {!isCanEdit ? 
                        <Grid item xs={12} md={4} >
                            <FormControl fullWidth variant="outlined" required>
                                <label style={{ fontWeight: "bold" }}>Extended Cost</label>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    disabled
                                    type="text"
                                    name="extendedCost"
                                    value={sitem.extendedCost || ""}
                                />
                            </FormControl>
                        </Grid>
                        : null}
                        
                        {sitem.justification && sitem.justification ? 
                        <Grid item xs={12} md={12}>
                            <label style={{ fontWeight: "bold" }}>Justification for excess quoted amount: </label>
                            <TextField
                                variant="outlined"
                                fullWidth
                                required
                                type="text"
                                name="justification"
                                value={sitem.justification || ""}
                                disabled
                            />
                        </Grid> : null}
                    </Grid>
                </Paper>
                ))}

                {/* {state.status !== "draft" ? (
                <Grid container spacing={2} className={classes.grid}>
                    <Grid item xs={12} md={6} />
                    <Grid item xs={12} md={2}>
                        <label style={{ fontWeight: "bold" }}>Total Quantity of Items</label>
                        <TextField
                            placeholder="Total Quantity of Items"
                            name="totalQuantityNeeded"
                            value={state.totalQuantityNeeded || "0"}
                            variant="outlined"
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <label style={{ fontWeight: "bold" }}>Total Budget Amount (NGN)</label>
                        <TextField
                            placeholder="Total Budget Amount"
                            name="totalBudgetAmount"
                            value={formatCurrency(state && state.totalBudgetAmount, "en-NG", "NGN") || 0}
                            variant="outlined"
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <label style={{ fontWeight: "bold" }}>Total Extended Amount (NGN)</label>
                        <TextField
                            placeholder="Total Extended Amount"
                            name="totalExtendedAmount"
                            value ={formatCurrency(state && state.totalExtendedAmount, "en-NG", "NGN") || 0}
                            variant="outlined"
                            fullWidth
                            disabled
                        />
                    </Grid>
                </Grid>
                ) : null} */}
                
                <Grid
                    container
                    alignItems="center"
                    wrap="nowrap"
                    spacing={1}
                    style={{ marginBottom: 5 }}
                >
                    <Grid item>
                        <Typography variant="overline" className={classes.title2}>
                            Audit Trail
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Icon className="fas fa-clipboard-list" color="disabled" />
                    </Grid>
                </Grid>
                <Paper variant="outlined" square className={classes.paper}>
                    <Grid container justify="space-between" alignItems="center" spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Paper
                                className={classes.auditContainer}
                                component="div"
                                elevation={1}
                                variant="outlined"
                                square
                            >
                                <span className={classes.auditTitle}>Created By</span>
                                <Divider orientation="vertical" flexItem />
                                <span className={classes.audit}>{state.createdBy && state.createdBy.userName}</span>
                                <Divider orientation="vertical" flexItem />
                                <span className={classes.audit}>{state.createdAt}</span>
                            </Paper>
                        </Grid>

                        {(state.submittedAt && state.submittedBy) && (
                            <>
                                <Grid item xs={12} md={12}>
                                    <Paper
                                        className={classes.auditContainer}
                                        component="div"
                                        elevation={1}
                                        variant="outlined"
                                        square
                                    >
                                        <span className={classes.auditTitle}>Submitted By</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.submittedBy && state.submittedBy.userName}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.submittedAt}</span>
                                    </Paper>
                                </Grid>
                            </>
                        )}
                        {(state.acceptedAt && state.acceptedBy) && (
                            <>
                                <Grid item xs={12} md={12}>
                                    <Paper
                                        className={classes.auditContainer}
                                        component="div"
                                        elevation={1}
                                        variant="outlined"
                                        square
                                    >
                                        <span className={classes.auditTitle}>Accepted By</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.acceptedBy && state.acceptedBy.userName}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.acceptedAt}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.auditTitle}>Comment</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.acceptComment}</span>
                                    </Paper>
                                </Grid>
                            </>
                        )}
                        {(state.rejectedAt && state.rejectedBy) && (
                            <>
                                <Grid item xs={12} md={12}>
                                    <Paper
                                        className={classes.auditContainer}
                                        component="div"
                                        elevation={1}
                                        variant="outlined"
                                        square
                                    >
                                        <span className={classes.auditTitle}>Rejected By</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.rejectedBy && state.rejectedBy.userName}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.rejectedAt}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.auditTitle}>Comment</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.rejectComment}</span>
                                    </Paper>
                                </Grid>
                            </>
                        )}
                        {(state.approvedAt && state.approvedBy) && (
                            <>
                                <Grid item xs={12} md={12}>
                                    <Paper
                                        className={classes.auditContainer}
                                        component="div"
                                        elevation={1}
                                        variant="outlined"
                                        square
                                    >
                                        <span className={classes.auditTitle}>Approved By</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.approvedBy && state.approvedBy.userName}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.approvedAt}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.auditTitle}>Comment</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.approveComment}</span>
                                    </Paper>
                                </Grid>
                            </>
                        )}
                        {(state.declinedAt && state.declinedBy) && (
                            <>
                                <Grid item xs={12} md={12}>
                                    <Paper
                                        className={classes.auditContainer}
                                        component="div"
                                        elevation={1}
                                        variant="outlined"
                                        square
                                    >
                                        <span className={classes.auditTitle}>Declined By</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.declinedBy && state.declinedBy.userName}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.declinedAt}</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.auditTitle}>Comment</span>
                                        <Divider orientation="vertical" flexItem />
                                        <span className={classes.audit}>{state.declineComment}</span>
                                    </Paper>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Paper>

                {isCanEdit && (state.status === "draft" || state.status === "declined" || state.status === "rejected") ?  (
                    <Grid container justify="center">
                        <Grid item>
                            <ButtonGroup>
                                <Button
                                    className={classes.saveBtn}
                                    color="primary"
                                    variant="contained"
                                    disabled={loading || validCheck()}
                                    onClick={handleSave}
                                >
                                    {loading ? "Loading..." : "Save Changes"}
                                </Button>
                                <Button
                                    type="submit"
                                    className={classes.saveBtn2}
                                    variant="contained"
                                    onClick={handleSubmitHandler}
                                    disabled={loading || validCheck()}
                                >
                                    {loading ? "Loading..." : "Submit"}
                                </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                ) : null}

                {/* ACTION BUTTONS */}
                {(isProcurement || isAdmin) && state.status === "submitted" ? (
                    <Grid container justify="center">
                        <Grid item>
                            <div className={classes.centered}>
                                <Paper className={classes.paperBlack}>
                                    <HelpOutlineIcon fontSize="large" />
                                    <Typography placeholder="Info" className={classes.info2}>
                                        These actions are to be carried out by the Supply Chain Division (PMG or SCM).
                                    </Typography>
                                </Paper>
                            </div>
                            <ButtonGroup>
                                <Button
                                    onClick={handleOpenAccept}
                                    className={classes.saveBtn2}
                                    variant="contained"
                                >
                                    Accept
                                </Button>
                                <Button
                                    onClick={handleOpenDecline}
                                    className={classes.saveBtn}
                                    color="secondary"
                                    variant="contained"
                                >
                                    Decline
                                </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                ) : null}

                {/* {(isProcurement || isAdmin) && state.status === "approved" ? (
                    <Grid container justify="center">
                        <Grid item>
                            <div className={classes.centered}>
                                <Paper className={classes.paperBlack}>
                                    <HelpOutlineIcon fontSize="large" />
                                    <Typography placeholder="Info" className={classes.info2}>
                                        This purchase requisition acceptance or decline is to be done by Procurement Division.
                                    </Typography>
                                </Paper>
                            </div>
                            <ButtonGroup>
                                <Button
                                    onClick={handleOpenAccept}
                                    className={classes.saveBtn2}
                                    variant="contained"
                                >
                                    Accept
                                </Button>
                                <Button
                                    onClick={handleOpenDecline}
                                    className={classes.saveBtn}
                                    color="secondary"
                                    variant="contained"
                                >
                                    Decline
                                </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                ) : null} */}
             </form>

            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default ViewRFQ;